import { Directive, ElementRef, inject, Input } from '@angular/core';
import { GoogleMapsService } from '@df/module-google-maps/google-maps.service';
import { AddressFieldsetComponentDef } from '@df/ui/form/address-fieldset.component.def';
import { GoogleMapsAddressService } from '../google-maps-address.service';

// it requires 'places' library added in google maps module configuration

@Directive()
export abstract class GoogleMapsAddressAutocompleteDirectiveDef {
    @Input()
    country?: string;

    private googleMapsService = inject(GoogleMapsService);
    private googleMapsAddressService = inject(GoogleMapsAddressService);

    constructor(
        private element: ElementRef,
        private addressFieldsetComponent: AddressFieldsetComponentDef
    ) {
        const inputElement = this.element.nativeElement as HTMLInputElement;
        if (inputElement) {
            this.googleMapsService.load().then(() => {
                this.googleMapsAddressService.createAutocomplete(inputElement, this.addressFieldsetComponent, this.country);
            });
        }
    }
}
